// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"styles_mainDiv__2-c-q","emailInput":"styles_emailInput__fr1Oi","generatorPage":"styles_generatorPage__174t8","invoicePreview":"styles_invoicePreview__3NW1x"};